import { View } from 'foundations-components/transitional/components/View';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { ModalOrInlineLayout } from './ModalOrInlineLayout';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LowLevelAuthErrorAlert } from './LowLevelAuthFlowView/LowLevelAuthErrorAlert';
import { AuthenticateError } from '../types/authErrors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Loading state shown while the auth configuration is being fetched.
 * Used by both `account/UnifiedAccountView` and `auth/UnifiedAuthModal`.
 */
export function AuthConfigLoadingState({
  isModal,
  onCancel
}) {
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: isModal ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.loadingDialogHeader"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }) : undefined,
    body: /*#__PURE__*/_jsx(View, {
      minBlockSize: "300px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered"
      })
    })
  });
}
/**
 * Error state shown when the auth configuration fails to load.
 * Used by both `account/UnifiedAccountView` and `auth/UnifiedAuthModal`.
 */
export function AuthConfigFetchFailureState({
  isModal,
  onClose,
  appName = '',
  isReauth = false,
  error
}) {
  const authError = error instanceof AuthenticateError ? error.toAuthError() : undefined;
  return /*#__PURE__*/_jsx(ModalOrInlineLayout, {
    isModal: isModal,
    header: isModal ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: appName ? isReauth ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.reconnectDialogHeader",
          options: {
            appName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.dialogHeader",
          options: {
            appName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.modal.loadingDialogHeader"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }) : undefined,
    body: /*#__PURE__*/_jsx(View, {
      minBlockSize: "300px",
      children: authError ? /*#__PURE__*/_jsx(LowLevelAuthErrorAlert, {
        appName: appName,
        error: authError,
        context: {
          appName,
          onCancel: onClose,
          onReset: onClose
        }
      }) : /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.errors.configuration.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "unifiedAuthCore.errors.configuration.body"
        })
      })
    })
  });
}